var exports = {
  "B": "ListFilterButton__ccIaF1",
};

module.exports = exports;
